import React from 'react';

function PartnerCard({
  link, image, imageAlt, name,
}) {
  return (
    <div className="partner__card">
      <a target="_blank" aria-label="see more about partner" className="partner__card-link" href={link} rel="noreferrer">
        <img className="partner__card-image" src={image} alt={imageAlt || name} />
      </a>
    </div>
  );
}

export default PartnerCard;
